import type { TConversation } from '@stores/chat-domain.types';

export const LOAD_THRESHOLD = 15;
export const CONVERSATION_ITEM_HEIGHT = 129;
export const SKELETON_COUNT = 3;
export const EMPTY_CONVERSATIONS: TConversation[] = [];

export const CONVERSATION_LIST_STRINGS = {
	NO_CONVERSATIONS: 'Você ainda não tem nenhuma conversa :(',
} as const;
